import { render, staticRenderFns } from "./WarehouseList.vue?vue&type=template&id=24227f92&"
import script from "./WarehouseList.vue?vue&type=script&lang=js&"
export * from "./WarehouseList.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseList.vue?vue&type=style&index=0&id=24227f92&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports